module.exports = __webpack_public_path__ + "assets/img/sabc_social_linkedin.svg?bc237eb57629d372614ffe71056f74a6";